export const AppConstants = {
    APP_NAME: 'WeCycle.',
}

export const ColorConstants = {
    COLOR_GREEN: '#19C26B'
}
